export default "__VITE_ASSET__BHOroyEF__"